import IzzyAnalyzeSuccessGif from '@/assets/images/izzy/analyze-success.gif'
import { cn } from '@/lib/utils'
import { IzzySpeechBubble } from '../speech-bubble'

interface IzzyAnalyzeSuccessProps {
  className?: string
  label?: string
}

export const IzzyAnalyzeSuccess = ({
  className,
  label
}: IzzyAnalyzeSuccessProps) => {
  return (
    <div className={cn('select-none', className)}>
      <img
        src={IzzyAnalyzeSuccessGif}
        alt="Izzy conseguiu ler e validar o histórico acadêmico"
      />
      <div>
        <IzzySpeechBubble className="absolute w-60 left-40 bottom-38 flex flex-col gap-3">
          <p>{label}</p>
        </IzzySpeechBubble>
      </div>
    </div>
  )
}
